import store from '@src/store';
import defaults from '@src/router/defaults';
import {FinancialItemListMode} from '@common/status';
const Workspace = require ('@common/Workspace');


// Workspace Workspace.name.ADMIN tem acesso ao workspace Workspace.name.COMPANY
// O primeiro workspace é utilizado para fazer um possível redirecionamento

const routes = [



  // VISITANT AND GENERIC
  // {
  //   path: '/',
  //   name: 'home',
  //   alias: ['/index.html'],
  //   component: () => lazyLoadView(import('@views/generic/nextHome')),
  // },
  {
    path: '/',
    name: 'home',
    alias: ['/index.html'],
    redirect: { name: 'client/login' }
    // component: () => lazyLoadView(import('@views/generic/nextHome')),
  },
  {
    path: '/oldHome',
    name: 'oldHome',
    component: () => lazyLoadView(import('@views/generic/nextHome')),
  },
  {
    path: '/quest/:email',
    name: 'quest',
    component: () => lazyLoadView(import('@views/visitant/Quest')),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => lazyLoadView(import('@views/visitant/Contact')),
  },
  {
    path: '/blog/:id?',
    name: 'blog',
    component: () => lazyLoadView(import('@views/generic/blog')),
  },
  {
    path: '/post/:id?',
    name: 'post',
    component: () => lazyLoadView(import('@views/generic/post')),
  },
  {
    path: '/aboutUs',
    name: 'ABoutUs',
    component: () => lazyLoadView(import('@views/visitant/About')),
  },
  {
    path: '/ResetPassword',
    name: 'ResetPassword',
    component: () => lazyLoadView(import('@views/generic/ResetPassword')),
  },
  {
    path: '/login',
    name: 'login',
    redirect: { name: 'client/login' }
  },
  {
    path: '/faq/:id?',
    name: 'faq',
    component: () => lazyLoadView(import('@views/visitant/Faq')),
  },
  {
    path: '/response/:companyId?/:slug?',
    name: 'response',
    component: () => lazyLoadView(import('@views/visitant/FormResponse')),
  },
  {
    path: '/admin/Changelog',
    name: 'admin/Changelog',
    component: () => lazyLoadView(import('@views/admin/Changelog')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/client/Changelog',
    name: 'client/Changelog',
    component: () => lazyLoadView(import('@views/client/Changelog')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },





  // CLIENT
  {
    path: '/client',
    redirect: { name: 'client/login' }
  },
  {
    path: '/client/login',
    name: 'client/login',
    component: () => lazyLoadView(import('@views/client/Login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: defaults.routeLogged[store.getters['auth/loggedIn']] });
        } else {
          next();
        }
      },
    },
  },
  {
    path: '/client/hours/:id?',
    name: 'client/hours',
    component: () => lazyLoadView(import('@views/client/Hours')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/dashboard/:id?',
    name: 'client/dashboard',
    component: () => lazyLoadView(import('@views/client/Dashboard')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/hospitals/:id?',
    name: 'client/hospitals',
    component: () => lazyLoadView(import('@views/client/Hospitals')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/surgeons/:id?',
    name: 'client/surgeons',
    component: () => lazyLoadView(import('@views/client/Surgeons')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/insurances/:id?',
    name: 'client/insurances',
    component: () => lazyLoadView(import('@views/client/Insurances')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/insurancePricesImport',
    name: 'client/insurancePricesImport',
    component: () => lazyLoadView(import('@views/client/InsurancePricesImport')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/events/:id?',
    name: 'client/events',
    component: () => lazyLoadView(import('@views/client/Events')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/notReadyEvents/:id?',
    name: 'client/notReadyEvents',
    component: () => lazyLoadView(import('@views/client/Events')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/select_company',
    name: 'client/select_company',
    component: () => lazyLoadView(import('@views/client/SelectCompany')),
    meta: {
      authRequired: true,
      workspace: Workspace.name.CLIENT
    },
  },
  {
    path: '/client/patients/:id?',
    name: 'client/patients',
    component: () => lazyLoadView(import('@views/client/Patients')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/integrations/:id?',
    name: 'client/integrations',
    component: () => lazyLoadView(import('@views/client/Integrations')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/integrationToFrom/:id?',
    name: 'client/integrationToFrom',
    component: () => lazyLoadView(import('@views/client/IntegrationToFrom.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/integrationsMultiples/:id?',
    name: 'client/integrationsMultiples',
    component: () => lazyLoadView(import('@views/client/IntegrationsMultiples')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/surgeon_integration/:id?',
    name: 'client/surgeon_integration',
    component: () => lazyLoadView(import('@views/client/integrations/SurgeonIntegrationEdit')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/anesthetist_integration/:id?',
    name: 'client/anesthetist_integration',
    component: () => lazyLoadView(import('@views/client/integrations/AnesthetistIntegrationEdit')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/healthInsurance_integration/:id?',
    name: 'client/healthInsurance_integration',
    component: () => lazyLoadView(import('@views/client/integrations/HealthInsuranceIntegrationEdit')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/hospital_integration/:id?',
    name: 'client/hospital_integration',
    component: () => lazyLoadView(import('@views/client/integrations/HospitalIntegrationEdit')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/BigData/:id?',
    name: 'client/BigData',
    component: () => lazyLoadView(import('@views/client/BigData')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/anesthetists/:id?',
    name: 'client/anesthetists',
    component: () => lazyLoadView(import('@views/client/Anesthetists')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
      // companyModules: {
      //   'anesthetists': ['list'],
      // }
    },
  },
  {
    path: '/client/profileEdit/:id?',
    name: 'client/profileEdit',
    component: () => lazyLoadView(import('@views/client/Profile')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/changePassword/',
    name: 'client/changePassword',
    component: () => lazyLoadView(import('@views/client/ChangePassword')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/integration/',
    name: 'client/integration',
    component: () => lazyLoadView(import('@components/client/Integration')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/about/',
    name: 'client/about',
    component: () => lazyLoadView(import('@views/client/About')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/invoices/:id?',
    name: 'client/invoices',
    component: () => lazyLoadView(import('@views/client/Invoices')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/batches/:id?',
    name: 'client/batches',
    component: () => lazyLoadView(import('@views/client/Batches')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/mandatoryFields/:id?',
    name: 'client/mandatoryFields',
    component: () => lazyLoadView(import('@views/client/MandatoryFields')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/reports/',
    name: 'client/reports',
    component: () => lazyLoadView(import('@views/client/Reports')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/scheduleConfig',
    name: 'client/scheduleConfig',
    component: () => lazyLoadView(import('@views/client/schedules/ScheduleConfig')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/SchedulesLimits/:id?',
    name: 'client/SchedulesLimits',
    component: () => lazyLoadView(import('@views/client/schedules/SchedulesLimits')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/VacationConfig',
    name: 'client/VacationConfig',
    component: () => lazyLoadView(import('@views/client/schedules/VacationConfig')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/ScheduleCharge/:id?',
    name: 'client/ScheduleCharge',
    component: () => lazyLoadView(import('@views/client/schedules/Charge')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/Demands/:id?',
    name: 'client/Demands',
    component: () => lazyLoadView(import('@views/client/schedules/Demands')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/ReportsSchedule/',
    name: 'client/ReportsSchedule',
    component: () => lazyLoadView(import('@views/client/schedules/ReportsSchedule')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/ReportsGenerator/',
    name: 'client/ReportsGenerator',
    component: () => lazyLoadView(import('@views/client/ReportsGenerator')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,

    },
  },


  // ADMIN
  {
    path: '/admin',
    redirect: { name: 'client/login' }
  },
  {
    path: '/admin/login',
    name: 'admin/login',
    redirect: { name: 'client/login' }
  },
  {
    path: '/admin/inbox',
    name: 'admin/inbox',
    component: () => lazyLoadView(import('@views/admin/Inbox')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/quiz',
    name: 'admin/quiz',
    component: () => lazyLoadView(import('@views/admin/quiz')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/dashboard/:id?',
    name: 'admin/dashboard',
    component: () => lazyLoadView(import('@views/admin/Dashboard')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/companies/:id?',
    name: 'admin/companies',
    component: () => lazyLoadView(import('@views/admin/Companies')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/companiesData/:id?',
    name: 'admin/companiesData',
    component: () => lazyLoadView(import('@views/admin/CompaniesData')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/admin_users/:id?',
    name: 'admin/admin_users',
    component: () => lazyLoadView(import('@views/admin/AdminUsers')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/specialties/:id?',
    name: 'admin/specialties',
    component: () => lazyLoadView(import('@views/admin/Specialties')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/Help/:id?',
    name: 'admin/Help',
    component: () => lazyLoadView(import('@views/admin/Faqs')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/HelpCategories/:id?',
    name: 'admin/HelpCategories',
    component: () => lazyLoadView(import('@views/admin/FaqsCategories')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/Forms/:id?',
    name: 'admin/Forms',
    component: () => lazyLoadView(import('@views/admin/Forms')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/FormsResponses/:id?',
    name: 'admin/FormsResponses',
    component: () => lazyLoadView(import('@views/admin/FormsResponses')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/admin/FormsCategories/:id?',
    name: 'admin/FormsCategories',
    component: () => lazyLoadView(import('@views/admin/FormsCategories')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/cbhpm/:id?',
    name: 'admin/cbhpm',
    component: () => lazyLoadView(import('@views/admin/cbhpm')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/integrations/:id?',
    name: 'admin/integrations',
    component: () => lazyLoadView(import('@views/admin/Integrations')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/events/:id?',
    name: 'admin/events',
    component: () => lazyLoadView(import('@views/admin/Events')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/accessProfiles/:id?',
    name: 'admin/accessProfiles',
    component: () => lazyLoadView(import('@views/admin/AccessProfiles')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/accessModules/:id?',
    name: 'admin/accessModules',
    component: () => lazyLoadView(import('@views/admin/AccessModules')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/accessActions/:id?',
    name: 'admin/accessActions',
    component: () => lazyLoadView(import('@views/admin/AccessActions')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/changes/:id?',
    name: 'admin/changes',
    component: () => lazyLoadView(import('@src/Changes')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/users/:id?',
    name: 'admin/users',
    component: () => lazyLoadView(import('@views/admin/Anesthetists')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/newTicket/:id?',
    name: 'admin/newTicket',
    component: () => lazyLoadView(import('@views/admin/NewTicket')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/about/',
    name: 'admin/about',
    component: () => lazyLoadView(import('@views/admin/About')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/Jobs/:id?',
    name: 'admin/Jobs',
    component: () => lazyLoadView(import('@views/admin/Jobs')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/VerifyProcedures/:id?',
    name: 'admin/VerifyProcedures',
    component: () => lazyLoadView(import('@views/admin/VerifyProcedures')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/Reports/:id?',
    name: 'admin/Reports',
    component: () => lazyLoadView(import('@views/admin/Reports')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/periodOfPayment/:id?',
    name: 'admin/periodOfPayment',
    component: () => lazyLoadView(import('@views/admin/PeriodOfPayment')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },


  {
    path: '/client/faq/:id?',
    name: 'client/faq',
    component: () => lazyLoadView(import('@views/client/Faq')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },



  {
    path: '/client/guidesOcr/:id?',
    name: 'client/guidesOcr',
    component: () => lazyLoadView(import('@views/client/GuidesOcr')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/companies/:id?',
    name: 'client/companies',
    component: () => lazyLoadView(import('@views/client/Companies')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/Forms/:id?',
    name: 'client/Forms',
    component: () => lazyLoadView(import('@views/client/Forms')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/FormsResponses/:id?',
    name: 'client/FormsResponses',
    component: () => lazyLoadView(import('@views/client/FormsResponses')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/FormsToResponse/:id?',
    name: 'client/FormsToResponse',
    component: () => lazyLoadView(import('@views/client/FormsToResponse')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/Cobrancas/:id?',
    name: 'client/Cobrancas',
    component: () => lazyLoadView(import('@views/client/financial/Cobrancas')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/chartOfAccounts/:id?',
    name: '/client/chartOfAccounts',
    component: () => lazyLoadView(import('@views/client/financial/ChartOfAccounts')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/billsToPayAndReceive/:id?',
    name: 'client/billsToPayAndReceive',
    component: () => lazyLoadView(import('@views/client/financial/BillsToPayAndReceive')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },




  /*  {
    path: '/register',
    redirect: { name: 'company/register' }
  },




    // Workspace.name.COMPANY
    {
      path: '/company/register',
      name: 'company/register',
      component: () => lazyLoadView(import('@views/company/register')),
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters['auth/loggedIn']) {
            // Redirect to the home page instead
            next({ name: defaults.routeLogged[store.getters['auth/loggedIn']] })
          } else {
            // Continue to the login page
            next()
          }
        },
      }
    },
    {
      path: '/company/profile',
      name: 'company/profile',
      component: () => lazyLoadView(import('@views/company/company_profile')),
      meta: {
        authRequired: true,
        workspace: 'Workspace.name.COMPANY'
      },
    },


    {
      path: '/company/users/:id?',
      name: 'company/users',
      component: () => lazyLoadView(import('@views/company/users')),
      meta: {
        authRequired: true,
        workspace: 'Workspace.name.COMPANY'
      },
    },
    {
      path: '/company',
      redirect: { name: 'company/login' }
    },
    {
      path: '/company/login',
      name: 'company/login',
      component: () => lazyLoadView(import('@views/company/login')),
      meta: {
        beforeResolve(routeTo, routeFrom, next) {
          // If the user is already logged in
          if (store.getters['auth/loggedIn']) {
            // Redirect to the home page instead
            next({ name: defaults.routeLogged[store.getters['auth/loggedIn']] })
          } else {
            // Continue to the login page
            next()
          }
        },
      },
    },


    // VISITANT

    {
      path: '/post/:id?',
      name: 'post',
      component: () => lazyLoadView(import('@views/visitant/post')),
      meta: {
        authRequired: false,
      },
    },
    {
      path: '/page/:id?',
      name: 'page',
      component: () => lazyLoadView(import('@views/visitant/page')),
      meta: {
        authRequired: false,
      },
    },
    {
      path: '/blog/:id?',
      name: 'blog',
      component: () => lazyLoadView(import('@views/visitant/blog')),
      meta: {
        authRequired: false,
      },
    },
  */




  /* {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/old/profile')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile/:username',
    name: 'username-profile',
    component: () => lazyLoadView(import('@views/old/profile')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their username
          .dispatch('users/fetchUser', { username: routeTo.params.username })
          .then((user) => {
            // Add the user to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.user = user
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'User' } })
          })
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({ user: route.params.user }),
  }, */
  {
    path: '/logout',
    name: 'logout',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const routeTmp = defaults.routeLogOut[store.getters['auth/loggedIn']];
        store.dispatch('auth/logOut');
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        );
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: routeTmp || 'login' } : { ...routeFrom });
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => lazyLoadView(import('@views/generic/_404')),
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    name: '*',
    // redirect: '404',
    component: () => lazyLoadView(import('@views/generic/_404')),
  },
  {
    path: '/test',
    name: 'test',
    component: () => lazyLoadView(import('@views/generic/Test'))
  },
  {
    path: '/test2',
    name: 'test2',
    component: () => lazyLoadView(import('@views/generic/Test2'))
  },
  {
    path: '/test3',
    name: 'test3',
    component: () => lazyLoadView(import('@views/generic/Test3'))
  },




  {
    path: '/tools/img',
    name: 'tools/img',
    component: () => lazyLoadView(import('@views/tools/Img'))
  },
  {
    path: '/tools/Language',
    name: 'tools/Language',
    component: () => lazyLoadView(import('@views/tools/Language')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/tools/cbhpm',
    name: 'tools/cbhpm',
    component: () => lazyLoadView(import('@views/tools/Cbhpm')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/tools/Json2Excel',
    name: 'tools/Json2Excel',
    component: () => lazyLoadView(import('@views/tools/Json2Excel')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/tools/MigrateCompany',
    name: 'tools/MigrateCompany',
    component: () => lazyLoadView(import('@views/tools/MigrateCompany.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/tools/MigrateUser',
    name: 'tools/MigrateUser',
    component: () => lazyLoadView(import('@views/tools/MigrateUser.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/tools/ParallelUniverse',
    name: 'tools/ParallelUniverse',
    component: () => lazyLoadView(import('@views/tools/ParallelUniverse.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    // Migração do financeiro antigo (userTransfers/paymentsSplitted) para financialItems, por
    // empresa e janela de competência. Ver docs/financial/Migracao.md.
    path: '/tools/MigrateFinancial',
    name: 'tools/MigrateFinancial',
    component: () => lazyLoadView(import('@views/tools/MigrateFinancial.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/tools/CheckTransactions',
    name: 'tools/CheckTransactions',
    component: () => lazyLoadView(import('@views/tools/CheckTransactions.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/tools/Fcm',
    name: 'tools/Fcm',
    component: () => lazyLoadView(import('@views/tools/Fcm.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/tools/EventsSnapshot',
    name: 'tools/EventsSnapshot',
    component: () => lazyLoadView(import('@views/tools/EventsSnapshot.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/tools/CompanyBackup',
    name: 'tools/CompanyBackup',
    component: () => lazyLoadView(import('@views/tools/CompanyBackup.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    // Scripts de verificação e correção do financeiro (saldos, extrato, plano de contas), por
    // empresa. Ver docs/financial/ScriptsFinanceiro.md.
    path: '/tools/FinancialScripts',
    name: 'tools/FinancialScripts',
    component: () => lazyLoadView(import('@views/tools/FinancialScripts.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },




  // FCM_INJECT_ROUTES  // Do not change that comment

  {
    path: '/client/FinancialItemGroups/:id?',
    name: 'client/FinancialItemGroups',
    component: () => lazyLoadView(import('@views/client/financial/FinancialItemsCategories.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/ExternalINSS/:id?',
    name: 'client/ExternalINSS',
    component: () => lazyLoadView(import('@views/client/financial/ExternalINSS.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/admin/RAGVolan/:id?',
    name: 'admin/RAGVolan',
    component: () => lazyLoadView(import('@views/admin/RAGVolan')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  {
    path: '/client/RecurrentPayments/:id?',
    name: 'client/RecurrentPayments',
    component: () => lazyLoadView(import('@views/client/financial/RecurrentPayments.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/FinancialStatements/:id?',
    name: 'client/FinancialStatements',
    component: () => lazyLoadView(import('@views/client/financial/FinancialStatements.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/FinancialItemsGroups/:id?',
    name: 'client/FinancialItemsGroups',
    component: () => lazyLoadView(import('@views/client/financial/FinancialStatements.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
    props: {
      listMode: FinancialItemListMode.GROUP
    }
  },

  {
    path: '/client/FactorTransfer/:id?',
    name: 'client/FactorTransfer',
    component: () => lazyLoadView(import('@views/client/FactorTransfer')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/Suppliers/:id?',
    name: 'client/Suppliers',
    component: () => lazyLoadView(import('@views/client/financial/Suppliers')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  // {
  //   path: '/client/AccountCards/:id?',
  //   name: 'client/AccountCards',
  //   component: () => lazyLoadView(import('@views/client/AccountCards')),
  //   meta: {
  //     authRequired: true,
  //     workspaces: [Workspace.name.CLIENT],
  //   },
  // },

  {
    path: '/client/BankAccounts/:id?',
    name: 'client/BankAccounts',
    component: () => lazyLoadView(import('@views/client/BankAccounts')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/admin/CardBrands/:id?',
    name: 'admin/CardBrands',
    component: () => lazyLoadView(import('@views/admin/CardBrands')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  {
    path: '/admin/Banks/:id?',
    name: 'admin/Banks',
    component: () => lazyLoadView(import('@views/admin/Banks')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  {
    path: '/admin/Releases/:id?',
    name: 'admin/Releases',
    component: () => lazyLoadView(import('@views/admin/Releases')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  {
    path: '/client/TypesOfPayment/:id?',
    name: 'client/TypesOfPayment',
    component: () => lazyLoadView(import('@views/client/TypesOfPayment.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/admin/Map',
    name: 'admin/Map',
    component: () => lazyLoadView(import('@views/admin/Map')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/BI',
    name: 'admin/BI',
    component: () => lazyLoadView(import('@views/admin/BI')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  {
    path: '/client/ImportCustom/:id?',
    name: 'client/ImportCustom',
    component: () => lazyLoadView(import('@views/client/ImportCustom')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/admin/DashboardOcr/:id?',
    name: 'admin/DashboardOcr',
    component: () => lazyLoadView(import('@views/admin/DashboardOcr')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  {
    path: '/admin/OcrAmazonCredit/:id?',
    name: 'admin/OcrAmazonCredit',
    component: () => lazyLoadView(import('@views/admin/OcrAmazonCredit')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  // Tela 'client/ExternalPayments' removida: usava o financeiro antigo (paymentsSplitted, uma
  // linha por tomador). No modelo novo esse registro vive dentro do financialItem
  // (valuesByTomador) e os relatórios "Resumo contábil PF/PJ" saem da tela de Contas a pagar e
  // receber (FinancialItems.vue → exportAccountingResume). A view foi mantida no repositório.
  // A rota permanece como redirect para não quebrar favoritos e links compartilhados.
  {
    path: '/client/ExternalPayments/:id?',
    redirect: '/client/FinancialItems',
  },

  {
    path: '/admin/GuideOcrAmazon/:id?',
    name: 'admin/GuideOcrAmazon',
    component: () => lazyLoadView(import('@views/admin/GuideOcrAmazon')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/GuideOcrAmazon/:id?',
    name: 'client/GuideOcrAmazon',
    component: () => lazyLoadView(import('@views/client/GuideOcrAmazon')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/UserTransfer/:id?',
    name: 'client/UserTransfer',
    component: () => lazyLoadView(import('@views/client/UserTransfer')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/admin/TypesOfPayment/:id?',
    name: 'admin/TypesOfPayment',
    component: () => lazyLoadView(import('@views/admin/TypesOfPayment')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/Backups/:id?',
    name: 'admin/Backups',
    component: () => lazyLoadView(import('@views/admin/Backups')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  {
    path: '/client/CustomFields/:id?',
    name: 'client/CustomFields',
    component: () => lazyLoadView(import('@views/client/CustomFields')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/TagsSchedule/:id?',
    name: 'client/TagsSchedule',
    component: () => lazyLoadView(import('@views/client/schedules/TagsSchedule')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/ConfigOnCallSchedule/:id?',
    name: 'client/ConfigOnCallSchedule',
    component: () => lazyLoadView(import('@views/client/schedules/ConfigOnCallSchedule')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/reportTransactions/:id?',
    name: 'client/reportTransactions',
    component: () => lazyLoadView(import('@views/client/financial/reportTransactions')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/SpreadsheetConfig/:id?',
    name: 'client/SpreadsheetConfig',
    component: () => lazyLoadView(import('@views/client/SpreadsheetConfig')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/Appeals/:id?',
    name: 'client/Appeals',
    component: () => lazyLoadView(import('@views/client/Appeals')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },

  {
    path: '/client/BillingContract/:id?',
    name: 'client/BillingContract',
    component: () => lazyLoadView(import('@views/client/financial/BillingContract')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/templatesImportEvents/:id?',
    name: 'client/templatesImportEvents',
    component: () => lazyLoadView(import('@views/client/templatesImportEvents')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/spreadsheetProcedureCodes/:id?',
    name: 'client/spreadsheetProcedureCodes',
    component: () => lazyLoadView(import('@views/client/spreadsheetProcedureCodes')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/periodOfPayment/:id?',
    name: 'client/periodOfPayment',
    component: () => lazyLoadView(import('@views/client/financial/PeriodOfPayment')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/core/:id?',
    name: 'client/core',
    component: () => lazyLoadView(import('@views/client/schedules/Core')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/contracts/:id?',
    name: 'client/contracts',
    component: () => lazyLoadView(import('@views/client/financial/Contracts')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/admin/Posts/:id?',
    name: 'admin/Posts',
    component: () => lazyLoadView(import('@views/admin/Posts')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/PostsCategories/:id?',
    name: 'admin/PostsCategories',
    component: () => lazyLoadView(import('@views/admin/PostsCategories')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/PostsPublishers/:id?',
    name: 'admin/PostsPublishers',
    component: () => lazyLoadView(import('@views/admin/PostsPublishers')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  {
    path: '/client/Taxes/:id?',
    name: 'client/Taxes',
    component: () => lazyLoadView(import('@views/client/financial/Taxes')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/Transfers/:id?',
    name: 'client/Transfers',
    component: () => lazyLoadView(import('@views/client/financial/Transfers')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/PaymentSlips/:id?',
    name: 'client/PaymentSlips',
    component: () => lazyLoadView(import('@views/client/financial/PaymentSlips')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },

  {
    path: '/client/workplaces/:id?',
    name: 'client/workplaces',
    component: () => lazyLoadView(import('@views/client/schedules/Workplaces')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/onCallSchedule/:id?',
    name: 'client/onCallSchedule',
    component: () => lazyLoadView(import('@views/client/schedules/OnCallSchedule')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/workloads/:id?',
    name: 'client/workloads',
    component: () => lazyLoadView(import('@views/client/schedules/Workloads')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/client/exceptionServices/:id?',
    name: 'client/exceptionServices',
    component: () => lazyLoadView(import('@views/client/schedules/ExceptionServices')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },

  {
    path: '/admin/VerifyEvents/:id?',
    name: 'admin/VerifyEvents',
    component: () => lazyLoadView(import('@views/admin/VerifyEvents')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/client/admin/BatchMigration',
    name: 'client/admin/BatchMigration',
    component: () => lazyLoadView(import('@views/client/admin/BatchMigration')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },
  {
    path: '/admin/QueryInFirestore/',
    name: 'admin/QueryInFirestore',
    component: () => lazyLoadView(import('@views/admin/QueryInFirestore')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.ADMIN],
    },
  },

  {
    path: '/client/Protocols/:id?',
    name: 'client/Protocols',
    component: () => lazyLoadView(import('@views/client/Protocols')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  // Financeiro do cooperado (empresa filial): movimentações da matriz em que a filial/usuário é o
  // negociador e que foram liberadas para ele. Substitui, para o cooperado, a tela legada
  // 'client/UserTransfer' (que lê `userTransfers`). Ver docs/financial/FinanceiroCooperado.md.
  {
    path: '/client/CoopFinancialItems/:id?',
    name: 'client/CoopFinancialItems',
    component: () => lazyLoadView(import('@views/client/financial/CoopFinancialItems')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
  },
  {
    path: '/client/FinancialItems/:id?',
    name: 'client/FinancialItems',
    component: () => lazyLoadView(import('@views/client/financial/FinancialItems')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
      needCompany: true,
    },
    props: {
      listMode: FinancialItemListMode.ALL
    }
  },
  {
    path: '/client/FinancialInvoices/:id?',
    name: 'client/FinancialInvoices',
    component: () => lazyLoadView(import('@views/client/financial/FinancialItems')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
    props: {
      listMode: FinancialItemListMode.ONLY_INVOICES
    }
  },
  {
    path: '/client/FinancialRecurrents/:id?',
    name: 'client/FinancialRecurrents',
    component: () => lazyLoadView(import('@views/client/financial/FinancialItems')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
    props: {
      listMode: FinancialItemListMode.ONLY_RECURRENT
    }
  },
  {
    path: '/client/BankReconciliation/:id?',
    name: 'client/BankReconciliation',
    component: () => lazyLoadView(import('@views/client/financial/BankReconciliation.vue')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },
  {
    path: '/client/RaqTest',
    name: 'client/RaqTest',
    component: () => lazyLoadView(import('@views/client/RaqTest')),
    meta: {
      authRequired: true,
      workspaces: [Workspace.name.CLIENT],
    },
  },


];


// Rotas apenas para dev
if(process.env.NODE_ENV !== 'production') {
  const requireModule = require.context(
    '../views/demos/',
    true,
    /^((?!index|\.unit\.).)*\.vue$/
  );
  const demoRoutes = [];
  requireModule.keys().forEach((fileName) => {
    const file = fileName.substr(2).split('.')[0];
    if(file!=='index') {
      routes.push({
        path: '/demos/'+file+'/:id?',
        name: 'demos/'+file,
        component: () => lazyLoadView(import('@views/demos/'+file))
      });
      demoRoutes.push('demos/'+file);
    }

  });

  routes.push({
    path: '/demos',
    name: 'demos',
    component: () => lazyLoadView(import('@views/demos/index')),
    meta: {
      demoRoutes: demoRoutes
    },
  });

}






// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView, params = {}) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/generic/_loading'),
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/generic/_timeout'),
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 32000,
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children);
    },
  });
}





export default routes;
